import React, { useEffect, useState } from 'react';
import axios from 'axios';
import SelectBox from 'devextreme-react/select-box';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import Button from 'devextreme-react/button';
import './App.css';

const API_BASE = 'https://qbo.omnivistaweb.com';

const EmployeeGratuityPage = () => {
  const [employees, setEmployees] = useState<string[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<string>('[ALL]');
  const [gratuityData, setGratuityData] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API_BASE}/api/employees`).then(res => {
      const sorted = ['[ALL]', ...res.data.sort((a: string, b: string) => a.localeCompare(b))];
      setEmployees(sorted);
    });
  }, []);

  const fetchGratuity = async () => {
    try {
      if (selectedEmployee === '[ALL]') {
        const res = await axios.get(`${API_BASE}/api/employees/gratuity`);
        setGratuityData(res.data);
      } else {
        const res = await axios.get(`${API_BASE}/api/employees/gratuity/${encodeURIComponent(selectedEmployee)}`);
        setGratuityData([res.data]);
      }
    } catch (err) {
      console.error('❌ Failed to fetch gratuity data:', err);
      alert('Failed to load gratuity data.');
    }
  };

  return (
    <div className="dashboard-wrapper" style={{ padding: 20 }}>
      {/* Top control section */}
      <div style={{ background: '#fff', padding: 16, borderRadius: 8, marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <SelectBox
            items={employees}
            value={selectedEmployee}
            onValueChanged={e => setSelectedEmployee(e.value)}
            placeholder="Select an employee"
            searchEnabled
            width={300}
          />
          <Button
            text="Search"
            type="default"
            stylingMode="contained"
            onClick={fetchGratuity}
            style={{ backgroundColor: 'var(--blue-primary)', color: '#fff' }}
          />
        </div>
      </div>

      {/* Gratuity result section */}
      <div style={{ background: '#fff', padding: 16, borderRadius: 8 }}>
        <h4 style={{ marginBottom: 16, color: '#1e1b4b' }}>Gratuity Results</h4>
        <DataGrid dataSource={gratuityData} showBorders columnAutoWidth>
          <Column dataField="display_name" caption="Display Name" />
          <Column dataField="employee_name" caption="Employee Name" />
          <Column dataField="years_of_service" caption="Years of Service" />
          <Column dataField="gratuity" caption="Gratuity (AED)" format={{ type: 'fixedPoint', precision: 2 }} />
        </DataGrid>
      </div>
    </div>
  );
};

export default EmployeeGratuityPage;